import React from "react";
import { Link } from "gatsby";
import PageSectionContainer from "../common/page-section-container";
import PageSectionHeading from "../common/page-section-heading";
import Img from "gatsby-image";
import { replaceQuotationMarksWithGuillemets } from "../../util/format/guillemets";
var MagazineItem = function MagazineItem(_ref) {
    var to = _ref.to, title = _ref.title, label = _ref.label, description = _ref.description, image = _ref.image, index = _ref.index;
    var containerStyle = index != undefined ? index % 3 === 0 ? "md:pr-4" : index % 3 === 1 ? "md:pl-2 md:pr-2" : "md:pl-4" : "";
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-6 md:mb-10 md:w-1/3 " + containerStyle
    }, /*#__PURE__*/ React.createElement(Link, {
        to: to,
        className: "block h-full"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "h-full"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: replaceQuotationMarksWithGuillemets(title),
        className: "mb-1"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-full flex flex-col px-4 md:pl-8 md:pr-5"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex-1"
    }, description, /*#__PURE__*/ React.createElement("div", {
        className: "font-medium text-right block mt-2"
    }, label)), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2",
        style: {
            maxWidth: "185px"
        }
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: image,
        className: "shadow-magazines"
    }))))));
};
export default MagazineItem;
